import { render, staticRenderFns } from "./LoginCardConfirmMailRequestCode.vue?vue&type=template&id=c20c25e8&scoped=true&"
import script from "./LoginCardConfirmMailRequestCode.vue?vue&type=script&lang=ts&"
export * from "./LoginCardConfirmMailRequestCode.vue?vue&type=script&lang=ts&"
import style0 from "./LoginCardConfirmMailRequestCode.vue?vue&type=style&index=0&id=c20c25e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c25e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
